import { render, staticRenderFns } from "./r-card-dropdown-dialog.vue?vue&type=template&id=849fe954&scoped=true"
import script from "./r-card-dropdown-dialog.vue?vue&type=script&lang=js"
export * from "./r-card-dropdown-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-card-dropdown-dialog.vue?vue&type=style&index=0&id=849fe954&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849fe954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849fe954')) {
      api.createRecord('849fe954', component.options)
    } else {
      api.reload('849fe954', component.options)
    }
    module.hot.accept("./r-card-dropdown-dialog.vue?vue&type=template&id=849fe954&scoped=true", function () {
      api.rerender('849fe954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card/r-card-dropdown-dialog.vue"
export default component.exports